var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup54(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168.54,
    height: 168.758,
    viewBox: "0 0 168.54 168.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 168.54,
    height: 64.469,
    transform: "translate(1220.07 1129.467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 115.16,
    height: 56.621,
    transform: "translate(1247.47 1183.995)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 117.2,
    height: 67.547,
    transform: "translate(1244.87 1071.859)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(-163.944 -2071.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-1056.125 999.996)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M1384.368,1166.472l-9.4,9.41c-15.27,1.53-27.12,7.1-36.84,11.66-7.18,3.37-13.37,6.28-18.58,6.39-5.96.16-14.3-4.56-22.36-9.09-9.67-5.45-19.69-11.09-29.14-10.84-10.9.27-16.38,2.21-27.72,8.04l-16.01-16a14.447,14.447,0,0,1-2.14-17.74c5.8-2.99,10.61-5.54,14.69-7.69,17.02-9,20.56-10.87,31.44-11.14,6.73-.18,15.48,4.77,23.98,9.55,9.65,5.44,18.77,10.56,27.47,10.38,7.33-.16,14.41-3.48,22.62-7.34,8.17-3.83,17.19-8.07,28.24-10.03l13.75,13.76a14.715,14.715,0,0,1,0,20.68"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-1056.125 999.996)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M1362.628,1188.442l-47.94,47.93a14.461,14.461,0,0,1-20.47,0l-46.75-46.75c8.67-4.32,12.7-5.42,20.84-5.62,6.71-.21,15.48,4.77,23.98,9.55,9.48,5.34,18.44,10.39,27.01,10.39.15,0,.31,0,.46-.01,7.33-.15,14.41-3.48,22.62-7.33a135.51,135.51,0,0,1,20.25-8.16"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-1056.125 999.996)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M1362.068,1123.7c-9.31,2.44-17.15,6.12-23.94,9.31-7.18,3.37-13.37,6.28-18.58,6.39-5.96.16-14.3-4.56-22.36-9.09-9.67-5.45-19.64-11.1-29.14-10.84-9.33.23-14.69,1.69-23.18,5.77l49.13-49.13a14.443,14.443,0,0,1,20.47,0Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup54);
export default __webpack_public_path__ + "static/media/Group 54.b1dee67423234d1e79b39e889cbd6385.svg";
export { ForwardRef as ReactComponent };